import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import './registerServiceWorker'
import ContactUs from './components/ContactUs.vue'
import { loadScript } from 'esri-loader'
Vue.config.productionTip = false
Vue.use(VModal,{ component: ContactUs })
// preload the ArcGIS API
const options = {
  url: 'https://js.arcgis.com/4.9/',
};
loadScript(options)

new Vue({
  router,
  store,
  VModal,
  render: h => h(App)
}).$mount('#app')

